import { render, staticRenderFns } from "./Sidemenu.vue?vue&type=template&id=58cc8913&scoped=true&"
import script from "./Sidemenu.vue?vue&type=script&lang=js&"
export * from "./Sidemenu.vue?vue&type=script&lang=js&"
import style0 from "./Sidemenu.vue?vue&type=style&index=0&id=58cc8913&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cc8913",
  null
  
)

export default component.exports